// extracted by mini-css-extract-plugin
export default {"logo":"CardAction_logo__O0doD","smallLogo":"CardAction_smallLogo__MYN+1"};